
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talks",
      function () {
        return require("private-next-pages/talks/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talks"])
      });
    }
  